
import XTable from 'vux/src/components/x-table/index.vue'

import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'

import timeLine from './timeLine.vue';
import payDialog from './payDialog.vue';
import orderJS from './order.js';
import doRefund from './doRefund.vue';
export default {
components: {
XTable,
Flow,
FlowState,
FlowLine,
timeLine,
payDialog,
doRefund
},
mixins: [orderJS],
data() {
/**
* 订单状态
* 0:待付款，1:待发货，2:待收货，3:已收货(交易成功)，4:退款中，
* 5:退款完成(交易关闭)，6:退货退款中，7:退货退款完成(交易关闭)，8:超时未付款，订单自动关闭(交易关闭)，9:订单已取消(交易关闭)
* 10.第三方退款中，11.第三方退款失败，12.第三方退货退款中，12.第三方退货退款失败
*/
return {
goodsOrderId: '',
goodsOrder: {
statusItem: {}
},
isEnd: false,
deliver: {
name: '',
phone: ''
},
logList: [],
serverTime: '' 
};
},
methods: {
goBack() {
this.$router.push('/mallMine?index=' + (this.activeIndex ? this.activeIndex : 0));
},
loadLogistics() {
let that = this;
that.logList = [];
that.$axios
.get('/api/v1.0/lonbonShop/viewLogistics', {
params: {
goodsOrderId: that.goodsOrderId
}
})
.then(function (response) {
if (response.status == 200) {
var one = that.goodsOrder;

that.isEnd = false;
var addressList = [];
var list = response.body.data;
if (list && list.length > 0) {

that.setDeliveryInfo(list);

for (var i = list.length - 1; i >= 0; i--) {
var item = list[i];
if (item.opCode == 50 || item.opCode == 54) {
item.title = '已揽件';
}
if (item.opCode == 80) {
item.title = '已签收';
}
if (item.opCode == 44 || item.opCode == 204) {
item.title = '派送中';
}
if (item.opCode != 8000) {
if (item.acceptTime) {
var acceptTimeArr = item.acceptTime.split(' ');
var dateArr = acceptTimeArr[0].split('-');
item.date = dateArr[1] + '-' + dateArr[2];
var timeArr = acceptTimeArr[1].split(':');
item.time = timeArr[0] + ':' + timeArr[1];
}
that.logList.push(item);


if (item.acceptAddress && addressList.indexOf(item.acceptAddress) < 0) {
addressList.unshift(item.acceptAddress);
}
}
if (item.opCode == 80) {
that.isEnd = true;
}


}
}


var addressArr = one.address.split(' ');
addressList.push(addressArr[0] + (addressArr[1] ? addressArr[1] : '') + (addressArr[2] ? addressArr[2] : ''));


/**
* 用于补充时间线
*/
if (that.goodsOrder.status > 0 && that.goodsOrder.status < 4) {
var disposeTimeArr = that
.$moment(one.disposeTime * 1000)
.format('MM-DD HH:mm')
.split(' ');
that.logList.push({
opCode: 1,
date: disposeTimeArr[0],
time: disposeTimeArr[1],
title: '已发货',
remark: '商品正在等待揽收'
});
}

var createTimeArr = that
.$moment(one.createTime * 1000)
.format('MM-DD HH:mm')
.split(' ');
that.logList.push({
opCode: 0,
date: createTimeArr[0],
time: createTimeArr[1],
title: '已下单',
remark: '商品已下单'
});

that.logList.unshift({
opCode: 9999,
remark: '[收货地址]' + one.address
});

/**
* 设置最近一次运输节点code为39
*/
that.setLastTransCode();
}
});
},
/**
* 标识最新一条的运输数据
*/
setLastTransCode() {
for (var i = 0; i < this.logList.length; i++) {
var opCode = this.logList[i].opCode;
if (opCode == 30 || opCode == 31 || opCode == 36) {
this.logList[i].opCode = 39;
this.logList[i].title = '运输中';
break;
}
}
},
/**
* 查询派送信息：快递员姓名和电话
*/
setDeliveryInfo(dataList) {
for (var i = 0; i < dataList.length; i++) {
var item = dataList[i];
var remark = item.remark;
var opCode = item.opCode;
if (opCode == 204) {
var nameObj = remark.match(/交给(\S*),正在/);
var phoneObj = remark.match(/联系电话：(\S*),顺丰/);
this.deliver = {
name: nameObj ? nameObj[1] : '',
phone: phoneObj ? phoneObj[1] : ''
};
}
if (opCode == 44) {
var arr = remark.match(/\(派件人:(\S*),电话:(\S*)\)/);
if (arr) {
this.deliver = {
name: arr[1],
phone: arr[2]
};
}
}
}
},
loadDetail(callback) {
let that = this;
that.$axios
.get('/api/v1.0/lonbonShop/orderDetails', {
params: {
goodsOrderId: that.goodsOrderId
}
})
.then(function (response) {
if (response.status == 200) {
var one = response.body;
one.createTimeStr = that.$moment(one.createTime * 1000).format('YYYY-MM-DD HH:mm:ss');
one.updateTimeeStr = that.$moment(one.updateTime * 1000).format('YYYY-MM-DD HH:mm:ss');
one.disposeTimeStr = that.$moment(one.disposeTime * 1000).format('YYYY-MM-DD HH:mm:ss');
one.payTimeStr = that.$moment(one.payTime * 1000).format('YYYY-MM-DD HH:mm:ss');
one.statusItem = that.$store.state.dict.statusStrList[one.status];
one.address = one.address.replace(/\s/g, '');
that.goodsOrder = one;

if (that.goodsOrder.status == 0) {
that.getServerTime(function () {
that.countDurationRemark();
clearInterval(window.countInterval);
window.countInterval = null;
window.countInterval = setInterval(() => {
that.countDurationRemark();
}, 1000);
});
} else {
clearInterval(window.countInterval);
window.countInterval = null;
}
that.loadLogistics();
callback && callback();
}
});
},
countDurationRemark() {
this.serverTime++;
var endT = this.goodsOrder.createTime + 24 * 3600;
var startT = new Date().getTime() / 1000;


if (startT <= this.serverTime) {


endT = endT - (this.serverTime - startT);
} else {

endT = endT + (startT - this.serverTime);
}
var duration = this.$countDuration(startT, endT, 'timestamp', 'second');
if (duration == '0秒') {
this.goodsOrder.status = 8;
this.goodsOrder.statusItem = this.$store.state.dict.statusStrList[this.goodsOrder.status];
clearInterval(window.countInterval);
window.countInterval = null;
} else {
this.goodsOrder.statusItem.remark = '剩' + duration + '自动关闭';
}
},

cancleOrder() {
let that = this;
that.cancleOrderFunc(that.goodsOrder, function () {
that.loadDetail();
});
},

deleteOrder() {
let that = this;
that.deleteOrderFunc(that.goodsOrder, function () {
that.goBack();
});
},

sureTake() {
let that = this;
that.sureTakeFunc(that.goodsOrder, function () {
that.loadDetail();
});
},

cancleRefund() {
let that = this;
that.$vux.confirm.show({
content: `您将撤销本次申请，如果问题未解决，您还可以再次发起。确定继续吗？`,
cancelText: '取消',
confirmText: '确定',
title: '提示',
onConfirm() {
var data = {
goodsOrderId: that.goodsOrder.goodsOrderId,
status: that.goodsOrder.status
};
that.$axios.put('/api/v1.0/lonbonShop/cancelApply', that.qs.stringify(data)).then(function (response) {
if (response.status == 200) {
that.$vux.toast.text('已撤销退款');
that.loadDetail();
}
});
}
});
},

showPayAction() {
this.$refs.payDialogRef.open(this.goodsOrder);
},

receiveMsg(obj) {
this.$refs.payDialogRef.checkStatus();
},

getServerTime(callback) {
let that = this;
that.$axios
.get('/api/v1.0/lonbonShop/getTime', {
params: {}
})
.then(function (res) {
if (res.status == 200) {
that.serverTime = res.body;
callback && callback();
}
});
}
},
mounted() {
let that = this;
this.goodsOrderId = this.$route.query.readyPayOrderId;
this.fromCart = this.$route.query.fromCart;
if (this.goodsOrderId) {
if (this.fromCart) {
if (window.history && window.history.pushState) {
history.pushState(null, null, document.URL); 
window.addEventListener('popstate', this.goBack, false);

}
}
this.loadDetail(function () {

var openPay = that.$route.query.openPay;
if (openPay && that.goodsOrder.status == 0) {
that.$nextTick(() => {
that.showPayAction();
});
}
});

this.activeIndex = this.$route.query.activeIndex;
this.$store.state.OrderDetailPage = this;
} else {
this.goBack();
}
},

destroyed() {
window.removeEventListener('popstate', this.goBack, false);
}
};



// WEBPACK FOOTER //
// ./src/pcComponents/mine/orderDetail.vue